import { Component, inject } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { AuthService } from '../../core/auth/auth.service';

@Component({
  selector: 'app-navbar',
  templateUrl: './Navbar.component.html',
  styleUrls: ['./Navbar.component.scss'],
  imports: [RouterLink, RouterLinkActive],
})
export class Navbar {
  private auth = inject(AuthService);

  handleLogout() {
    this.auth.logOut();
  }
}
